module.exports = __webpack_public_path__ + "media/icons/csv-file-a377e168.png";